// extracted by mini-css-extract-plugin
export default {"deductions":"ScratchedCompetitorDeductions_deductions__Mf33a","label":"ScratchedCompetitorDeductions_label__AqAA5","noDeductions":"ScratchedCompetitorDeductions_noDeductions__-ePqc"};